


































































import {
  Component,
  Vue,
  Prop,
  Watch
} from "vue-property-decorator";
import bcdata from "../assets/data";
import NavMenu from '@/components/NavMenu.vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import {
  ArchItem
} from '../model/data-model';

@Component({
  components: {
    NavMenu,
    [VueQrcode.name]: VueQrcode,
  }
})
export default class A4Paper extends Vue {

  private archData = bcdata.archData;
  private typeData = bcdata.typeData;
  private ecoData = bcdata.ecoData;
  private riskData = bcdata.riskData;
  private bcArchData: ArchItem[] = [];
  private coins: any[] = [];
  private testData: any;
  private type: "sticker" | "red" | "blue" | "helper" | "binary" | "coins" | null = null;

  constructor() {
    super();
  }

  beforeMount() {
    this.update();
  }

  @Watch("$route")
  routeChanged(to: any, from: any) {
    this.update();
  }

  update() {
    this.type = < any > this.$route.params.id;
    if (this.type == "sticker") {
      this.bcArchData = bcdata.archList.sort((a, b) => a.id - b.id);
      this.bcArchData.splice(20);
    } else if (this.type == "coins") {
      this.coins = [{
        "name": "Bitcoin",
        "symbol": "BTC"
      }, {
        "name": "Ethereum",
        "symbol": "ETH"
      }, {
        "name": "XRP",
        "symbol": "XRP"
      }, {
        "name": "Bitcoin Cash",
        "symbol": "BCH"
      }, {
        "name": "Litecoin",
        "symbol": "LTC"
      }, {
        "name": "EOS",
        "symbol": "EOS"
      }, {
        "name": "Binance Coin",
        "symbol": "BNB"
      }, {
        "name": "Bitcoin SV",
        "symbol": "BSV"
      }, {
        "name": "Stellar",
        "symbol": "XLM"
      }, {
        "name": "Cardano",
        "symbol": "ADA"
      }, {
        "name": "Monero",
        "symbol": "XMR"
      }, {
        "name": "TRON",
        "symbol": "TRX"
      }, {
        "name": "IOTA",
        "symbol": "MIOTA"
      }, {
        "name": "Dash",
        "symbol": "DASH"
      }, {
        "name": "Tezos",
        "symbol": "XTZ"
      }, {
        "name": "Ethereum Classic",
        "symbol": "ETC"
      }, {
        "name": "NEO",
        "symbol": "NEO"
      }, {
        "name": "Cosmos",
        "symbol": "ATOM"
      }, {
        "name": "NEM",
        "symbol": "XEM"
      }, {
        "name": "Ontology",
        "symbol": "ONT"
      }, {
        "name": "Dogecoin",
        "symbol": "DOGE"
      }, {
        "name": "Zcash",
        "symbol": "ZEC"
      }, {
        "name": "VeChain",
        "symbol": "VET"
      }, {
        "name": "Decred",
        "symbol": "DCR"
      }, {
        "name": "Qtum",
        "symbol": "QTUM"
      }, {
        "name": "Ravencoin",
        "symbol": "RVN"
      }, {
        "name": "Bitcoin Gold",
        "symbol": "BTG"
      }, {
        "name": "Lisk",
        "symbol": "LSK"
      }, {
        "name": "Nano",
        "symbol": "NANO"
      }, {
        "name": "DigiByte",
        "symbol": "DGB"
      }, {
        "name": "Bitcoin Diamond",
        "symbol": "BCD"
      }, {
        "name": "Waves",
        "symbol": "WAVES"
      }, {
        "name": "ICON",
        "symbol": "ICX"
      }, {
        "name": "BitShares",
        "symbol": "BTS"
      }, {
        "name": "Bytecoin",
        "symbol": "BCN"
      }, {
        "name": "MonaCoin",
        "symbol": "MONA"
      }, {
        "name": "THETA",
        "symbol": "THETA"
      }, {
        "name": "Komodo",
        "symbol": "KMD"
      }, {
        "name": "Siacoin",
        "symbol": "SC"
      }, {
        "name": "IOST",
        "symbol": "IOST"
      }, {
        "name": "Ardor",
        "symbol": "ARDR"
      }, {
        "name": "Bytom",
        "symbol": "BTM"
      }, {
        "name": "Verge",
        "symbol": "XVG"
      }, {
        "name": "Steem",
        "symbol": "STEEM"
      }, {
        "name": "Zilliqa",
        "symbol": "ZIL"
      }, {
        "name": "Zcoin",
        "symbol": "XZC"
      }, {
        "name": "Aeternity",
        "symbol": "AE"
      }, {
        "name": "Metaverse ETP",
        "symbol": "ETP"
      }, {
        "name": "Electroneum",
        "symbol": "ETN"
      }, {
        "name": "Factom",
        "symbol": "FCT"
      }, {
        "name": "Stratis",
        "symbol": "STRAT"
      }, {
        "name": "Beam",
        "symbol": "BEAM"
      }, {
        "name": "Elastos",
        "symbol": "ELA"
      }, {
        "name": "Grin",
        "symbol": "GRIN"
      }, {
        "name": "ReddCoin",
        "symbol": "RDD"
      }, {
        "name": "NULS",
        "symbol": "NULS"
      }, {
        "name": "Horizen",
        "symbol": "ZEN"
      }, {
        "name": "Aion",
        "symbol": "AION"
      }, {
        "name": "Nebulas",
        "symbol": "NAS"
      }, {
        "name": "WaykiChain",
        "symbol": "WICC"
      }];
    } else {
      if (this.type == "binary") {
        this.testData = [{
            content: '1',
            color: '#e850a8',
            class: 'bignumber',
          },
          {
            content: '0',
            color: '#66ccff',
            class: 'bignumber',
          },
        ];
      } else {
        this.testData = [{
            content: '',
            backColor: '#66ccff',
            class: 'block',
          },
          {
            content: '',
            backColor: '#e850a8',
            class: 'block',
          },
          {
            content: '',
            backColor: '#66cc33',
            class: 'block',
          },
          {
            content: '',
            backColor: 'black',
            class: 'block',
          },
        ];

        if (this.type == "red") {
          this.testData = [this.testData[1]];
        } else if (this.type == "blue") {
          this.testData = [this.testData[0]];
        } else if (this.type == "helper") {
          this.testData = Array(15).fill(this.testData[0])
            .concat(Array(15).fill(this.testData[1]))
            .concat(Array(25).fill(this.testData[2]))
            .concat(Array(5).fill(this.testData[3]));
        }
      }
    }
  }
}
